import { isWholeQuantity } from './is-whole-quantity.js';
/** True when a quantity input value is fractional on a UOM that requires whole numbers. */
export function isIntegralQuantityViolation(value, integral) {
    const parsed = typeof value === 'number' ? value : Number(value);
    return (integral && value !== '' && value != null && Number.isFinite(parsed) && !isWholeQuantity(parsed));
}
//# sourceMappingURL=is-integral-quantity-violation.js.map